import { React, useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import urls, { getCsrfToken } from '../com.zedock.common.script/urls.js';
import { clicks, useHandleAddToCart } from '../com.zedock.common.script/common.js';

import '../com.zedock.common.style/Specification.css';
import '../com.zedock.common.style/common.css';

function Specifications() {
  const navigate = useNavigate();
  const location = useLocation();
  const addToCartFunc = useHandleAddToCart();

  const { state } = useLocation();
  const [mainImage, setMainImage] = useState(null); // 1 or 2

  window.scrollTo({ top: 0, behavior: 'instant' });

  useEffect(() => {
    clicks(location.pathname);
    addToRecentyViewed();
  }, []);

  const addToRecentyViewed = async () => {
    try {
      const response = await
        fetch(`${urls.BASE_URL}` + "/zedock-web/viewedProducts", {
          method: "POST",
          credentials: "include",
          headers: {
            "Content-Type": "application/json",
            "X-XSRF-TOKEN": getCsrfToken()
          },
          body: JSON.stringify({
            id: state.id,
          })
        });
    } catch (error) {
      console.error("Error:", error);
    } finally {
    }
  };


  return (
    <div className="container px-0    ">

      <div className="zd-wrap px-2 px-lg-4 py-3">

        <div className="row m-1">
          <nav aria-label="breadcrumb" className="zd-crumb">
            <ol className="breadcrumb mb-0">
              <li className="breadcrumb-item">
                <a href="" onClick={() => navigate("/Product")}>Home</a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">Specifications</li>
            </ol>
          </nav>
        </div>

        <div className="row m-1">

          {/* ---------------- gallery ---------------- */}
          <div className="col-12 col-lg-5">
            <div className="zd-gallery">
              <div className="zd-gallery-main">
                <img src={mainImage === null
                  ? `${urls.CDN_URL + 'products/' + state.sku}.webp`
                  : `${urls.CDN_URL + 'products/' + state.sku}_${mainImage}.webp`} alt={state.name} />
              </div>
              <div className="zd-thumb-row">
                <div className={`zd-thumb ${mainImage === null ? "active" : ""}`} onClick={() => setMainImage(null)}>

                  <img src={`${urls.CDN_URL + 'products/' + state.sku}.webp`} alt={`${state.name} view `} />
                </div>
                <div className={`zd-thumb ${mainImage === 1 ? "active" : ""}`} onClick={() => setMainImage(1)}>

                  <img src={`${urls.CDN_URL + 'products/' + state.sku}_1.webp`} alt={`${state.name} view 1`} />
                </div>
                <div className={`zd-thumb ${mainImage === 2 ? "active" : ""}`} onClick={() => setMainImage(2)}>

                  <img src={`${urls.CDN_URL + 'products/' + state.sku}_2.webp`} alt={`${state.name} view 2`} />
                </div>
                <div className={`zd-thumb ${mainImage === 3 ? "active" : ""}`} onClick={() => setMainImage(3)}>

                  <img src={`${urls.CDN_URL + 'products/' + state.sku}_3.webp`} alt={`${state.name} view 3`} />
                </div>


              </div>
            </div>
          </div>

          {/* ---------------- purchase panel ---------------- */}
          <div className="col-12 col-lg-3">
            <div className="zd-purchase-panel">
              <span className="zd-purchase-eyebrow">Order summary</span>
              <h3>₹{state.price}</h3>
              <p className="zd-purchase-sub">Inclusive of all taxes</p>

              <button type="button" className="zd-add-cart" onClick={(e) => addToCartFunc(state.id,1)}>
                <img src={urls.CDN_URL + "cart.webp"} alt="" height={20} width={20} />
                Add to cart
              </button>

              <div className="zd-trust-row">
                <span className="zd-trust-item"><span className="dot"></span>Easy returns</span>
                <span className="zd-trust-item"><span className="dot"></span>Secure checkout</span>
                <span className="zd-trust-item"><span className="dot"></span>Fast delivery</span>
              </div>
            </div>
          </div>
          {/* ---------------- info panel ---------------- */}
          <div className="col-12 col-lg-4">
            <div className="zd-info-panel">
              <span className="zd-info-eyebrow">Product details</span>
              <h4>{state.name}</h4>
              <span className="zd-info-price">₹{state.price}</span>

              <hr className="zd-divider" />

              <h5 className="zd-desc-label">About this item</h5>
              <div className="zd-quote">
                <i className="fa fa-quote-left" aria-hidden="true"></i>
                <p>{state.description}</p>
              </div>

              <h5 className="zd-desc-label">Rating</h5>

              <div class="zd-quote rating">
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
                <span>★</span>
              </div>
            </div>
          </div>


        </div>

      </div>

    </div>
  );
}

export default Specifications;
